import React from 'react';
import { Radio } from 'antd';
import { isArray } from 'lodash';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value) {
      this.setState({value: nextProps.value});
    }
  }

  onChange = e => {
    const { value } = this.state;
    const { onChange } = this.props;
    this.setState({value: e.target.value});
    typeof onChange === 'function' && onChange(e.target.value);
  } 

  render() {
    const { value } = this.state;
    const { datas, className } = this.props;
    return (
      <div className={`list-sort-up ${className}`}>
        <Radio.Group value={value} onChange={this.onChange}>
          {isArray(datas) && datas.map(listItem => 
              <Radio.Button key={listItem.value} value={listItem.value}>{listItem.label}</Radio.Button>
          )}
        </Radio.Group>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/util/RadioSort.js